export const COMMENTS_POST_REQUEST = 'COMMENTS_POST_REQUEST';
export const COMMENTS_POST_FAILURE = 'COMMENTS_POST_FAILURE';
export const COMMENTS_POST_SUCCESS = 'COMMENTS_POST_SUCCESS';